import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {RuleActionContainerModel} from "../../../../../../../models/aggregates/alg/cc/rule-action";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class RuleActionService extends BaseApiTemplateService<RuleActionContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'rule-actions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'rule-actions';
    this.httpClient = http;
  }
}